export const NXLogReportIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M26.695 8H33V32.1429H26.695V8Z" fill="black" />
      <path d="M23.1571 13.6457H16.8521V32.1429H23.1571V13.6457Z" fill="black" />
      <path d="M13.305 20.0807H7V32.1429H13.305V20.0807Z" fill="black" />
    </svg>
  )
}
